import { Navigate } from 'react-router-dom'

const Versions = () => <Navigate to="/time-table/generate" replace />

export default Versions
